// Texas Christian University's undergraduate majors (#2652). Read on
// 2026-10-01 from TCU's official Majors & Programs finder on tcu.edu (its
// data file, tcu.edu/academics/programs/index.json, filtered to programs
// marked bachelor), which tags each program with the college that offers it
// and lists its degrees. Every bachelor's degree is kept (BA, BS, BBA, BFA,
// BM, BME, BSE, BGS, BSW), one line per degree; minors, certificates,
// graduate degrees and the Artist Diploma are left out. Departure: the
// 2026-2027 undergraduate catalog (undergraduate.catalog.tcu.edu, Coursedog)
// lists 1,595 program records mixed with graduate, retired and test entries
// and no college grouping, so the program finder is the source. The finder
// also tags every program with the John V. Roach Honors College, which
// offers no major of its own; that tag is ignored. The KB's majors list was
// the starting point; the official finder wins.
const majors = {
    "slug": "texas-christian-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in TCU's official Majors & Programs finder, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "AddRan College of Liberal Arts",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Race and Ethnic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Criminology & Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Digital Culture and Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics & Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BGS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Economics",
                    "degree": "BA"
                },
                {
                    "name": "International Economics",
                    "degree": "BS"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Modern Language Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish and Hispanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women & Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women & Gender Studies",
                    "degree": "BS"
                },
                {
                    "name": "Writing and Rhetoric",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Bob Schieffer College of Communication",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Cinema and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Film, Television and Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "Film, Television and Digital Media",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Sports Broadcasting",
                    "degree": "BA"
                },
                {
                    "name": "Sports Broadcasting",
                    "degree": "BS"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Louise Dilworth Davis College of Science & Engineering",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BA"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Astronomy & Physics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Child Development",
                    "degree": "BS"
                },
                {
                    "name": "Child Development",
                    "degree": "BA"
                },
                {
                    "name": "Computer Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Earth Systems Science",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Food Management",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Ranch Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Early Childhood-6th Grade Education",
                    "degree": "BSE"
                },
                {
                    "name": "Educational Studies",
                    "degree": "BSE"
                },
                {
                    "name": "Interdisciplinary Inquiry",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Inquiry",
                    "degree": "BS"
                },
                {
                    "name": "Middle School Education",
                    "degree": "BSE"
                },
                {
                    "name": "Professional Aviation",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSE"
                },
                {
                    "name": "Youth Advocacy and Educational Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Brass",
                    "degree": "BM"
                },
                {
                    "name": "Brass",
                    "degree": "BME"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Design Studies",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BME"
                },
                {
                    "name": "Music Theory & Composition",
                    "degree": "BM"
                },
                {
                    "name": "Percussion",
                    "degree": "BM"
                },
                {
                    "name": "Percussion",
                    "degree": "BME"
                },
                {
                    "name": "Piano",
                    "degree": "BM"
                },
                {
                    "name": "Piano Pedagogy",
                    "degree": "BM"
                },
                {
                    "name": "Strings",
                    "degree": "BM"
                },
                {
                    "name": "Strings",
                    "degree": "BME"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Voice",
                    "degree": "BM"
                },
                {
                    "name": "Voice",
                    "degree": "BME"
                }
            ]
        },
        {
            "name": "Harris College of Nursing & Health Sciences",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Health & Fitness",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Movement Science",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Speech, Language & Hearing Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Neeley School of Business",
            "source": {
                "label": "TCU Majors & Programs (undergraduate program finder)",
                "url": "https://www.tcu.edu/academics/programs/index.php"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Finance With Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        }
    ]
};

export default majors;
